import {
  createStore
} from 'vuex'
import app from '@/store/modules/app'
import background from '@/store/modules/background'
import user from '@/store/modules/user'
import other from '@/store/modules/other'
import getters from '@/store/getters'

export default createStore({
  modules: {
    app,
    background,
    user,
    other
  },
  getters
})